import { TPlant } from '../../types';

export type TP_Common = {
} & TPlant

export const schema = 'AutomationApps.Plants.Commons.P_Common';